export default __webpack_public_path__ + "static/media/work-two.047d7df9.PNG";